/**
 * Requirement-61 message catalogue. English is the accepted contract fallback;
 * locale-specific translations can override any key in their existing JSON.
 */
const merchandisingMessages = {
  "merchandising.selectionPreview.saveIncomplete": "Finish each group’s settings before saving this selection.",
  "merchandising.matching.phrasesHelp": "The rule can apply to any search phrase listed above.",
  "merchandising.matching.containsLabel": "Contains phrase",
  "merchandising.matching.exactHelp": "Matches a complete listed phrase. Letter case and extra spaces are ignored.",
  "merchandising.matching.formsHelp": "Word forms and word order can vary. No extra words.",
  "merchandising.matching.conceptHelp": "Matches a listed phrase inside a longer query, including word forms. The phrase keeps its word order.",
  "merchandising.matching.phrasesTitle": "Search phrases",
  "merchandising.matching.moreOptions": "More matching options",
  "merchandising.matching.additionalPhrases": "Also match these phrases",
  "merchandising.matching.additionalHelp": "Each line is another alternative, like the search phrases above.",
  "merchandising.matching.excludedPhrases": "Never match these phrases",
  "merchandising.matching.excludedHelp": "A matching phrase prevents this rule from applying, even if a search phrase matches.",
  "merchandising.matching.testPrompt": "Enter a shopper’s query to test it.",
  "merchandising.matching.checking": "Checking query…",
  "merchandising.matching.positive": "Matches this test query",
  "merchandising.matching.negative": "Does not match this test query",
  "merchandising.matching.negativeHelp": "Try one of the listed search phrases, add another phrase, or choose a broader matching option.",
  "merchandising.matching.excluded": "Blocked by an excluded phrase",
  "merchandising.matching.excludedResultHelp": "The query contains a phrase from Never match these phrases.",
  "merchandising.matching.addPhrase": "Add search phrase",
  "merchandising.response.inspectorTitle": "Response and settings",
  "merchandising.response.selectionTitle": "Product selection",
  "merchandising.response.selectionUpdating": "Updating selection…",
  "merchandising.response.selectionHelp": "Choose products from the catalog or search results.",
  "merchandising.response.savedAdjustments": "Saved category and brand adjustments",
  "merchandising.response.reviewChanges": "Review changes",
  "merchandising.selectionPreview.title": "Matching products",
  "merchandising.selectionPreview.count": "{count, plural, =0 {0 products} one {# product} other {# products}}",
  "merchandising.selectionPreview.estimatedCount": "About {count, plural, one {# product} other {# products}}",
  "merchandising.selectionPreview.validating": "Checking group…",
  "merchandising.selectionPreview.loading": "Loading products…",
  "merchandising.selectionPreview.invalid": "Finish the group’s filters to see matching products.",
  "merchandising.selectionPreview.error": "Could not load matching products.",
  "merchandising.selectionPreview.retry": "Try again",
  "merchandising.selectionPreview.sample": "Sample of {shown} matching products",
  "merchandising.selectionPreview.empty": "No products match this group.",
  "merchandising.selectionPreview.productsLabel": "Matching products for {group}",
  'merchandising.condition.groupWithPrevious': 'Group with previous filter',
  'merchandising.advanced.combineGroups': 'Add products from each group to one selection. Products that appear in several groups are included once.',
  'merchandising.advanced.productsFrom': 'Products from',
  'merchandising.advanced.allCatalog': 'All catalog',
  'merchandising.advanced.searchResults': 'Search results',
  'merchandising.advanced.searchQuery': 'Search query',
  'merchandising.advanced.refineProducts': 'Refine these products',
  'merchandising.advanced.searchConditionsOptional': 'Use all results of this search, or add conditions to narrow them down.',
  'merchandising.advanced.chooseConditions': 'Choose the conditions for this group, or start from search results.',
  'merchandising.advanced.addProductGroup': 'Add product group',
  'merchandising.advanced.editGroup': 'Edit group {number}',
  'merchandising.advanced.noResults': 'No results',
  'merchandising.advanced.emptyPreviewMessage': 'Your message to shoppers will appear here.',
  'merchandising.advanced.locale.ru': 'Russian',
  'merchandising.advanced.locale.en': 'English',

  'merchandising.advanced.brand': 'Brand',
  'merchandising.advanced.price': 'Price',
  'merchandising.advanced.matcherHelp': 'Test with the same matcher used by shopper search.',
  'merchandising.advanced.locale': 'Matching language',
  'merchandising.advanced.phraseLimits': 'One phrase per line; up to 32 phrases of 100 characters each.',
  'merchandising.advanced.sourceQuery': 'Optional search phrase for this group',
  'merchandising.advanced.and': 'AND',
  'merchandising.advanced.field': 'Catalog field',
  'merchandising.advanced.operator': 'Condition',
  'merchandising.advanced.operator.in': 'Is one of',
  'merchandising.advanced.operator.contains_any': 'Contains any',
  'merchandising.advanced.operator.gte': 'At least',
  'merchandising.advanced.operator.lte': 'At most',
  'merchandising.advanced.operator.between': 'Between',
  'merchandising.advanced.lowerBound': 'Value or minimum',
  'merchandising.advanced.upperBound': 'Maximum',
  'merchandising.advanced.removeCondition': 'Remove condition {number}',
  'merchandising.advanced.descendants': 'Include subcategories',
  'merchandising.advanced.addCondition': 'Add condition',
  'merchandising.advanced.discardSelection': 'Your selection edits have not been applied to this rule.',
  'merchandising.advanced.replaceActionsTitle': 'Replace incompatible saved changes?',
  'merchandising.advanced.replaceActionsBody': 'Publishing this response removes saved actions that cannot be used in this mode. Local drafts remain available until you leave the editor.',
  'merchandising.advanced.replaceActions': 'Change response',
  'merchandising.advanced.unsupported': 'This rule uses response or matching settings that this integration cannot edit. Its saved data is preserved.',
  'merchandising.advanced.invalidResponse': 'Complete the response settings before saving or previewing.',
  'merchandising.advancedPrototype.eyebrow': 'Search Rules',
  'merchandising.advancedPrototype.title': 'Silver jewelry response',
  'merchandising.advancedPrototype.description': 'Control when this rule matches and what shoppers see.',
  'merchandising.advancedPrototype.back': 'Back to search rules',
  'merchandising.advancedPrototype.previewAction': 'Preview prototype',
  'merchandising.advancedPrototype.localOnly': 'Prototype only — changes stay in this browser and are never published.',
  'merchandising.advancedPrototype.localUpdated': 'Preview updated locally. Nothing was sent to the backend.',
  'merchandising.advancedPrototype.query': 'Search query',
  'merchandising.advancedPrototype.queryValue': 'silver ring',
  'merchandising.advancedPrototype.conceptMatching': 'Concept matching',
  'merchandising.advancedPrototype.previewLabel': 'Search results preview',
  'merchandising.advancedPrototype.previewFor': 'Preview for “{query}”',
  'merchandising.advancedPrototype.previewMode': 'Preview version',
  'merchandising.advancedPrototype.previewDraft': 'Result',
  'merchandising.advancedPrototype.previewOriginal': 'Original',
  'merchandising.advancedPrototype.previewChanges': 'Changes',
  'merchandising.advancedPrototype.originalContext': 'Natural results before this rule.',
  'merchandising.advancedPrototype.changesContext': 'Only products affected by the draft.',
  'merchandising.advancedPrototype.productsFound': '{count} products in this preview',
  'merchandising.advancedPrototype.ruleSettings': 'Rule settings',
  'merchandising.advancedPrototype.responseTitle': 'Response',
  'merchandising.advancedPrototype.responseHelp': 'Choose the candidate set before pinning or hiding individual products.',
  'merchandising.advancedPrototype.responseLabel': 'Response type',
  'merchandising.advancedPrototype.responseSearch': 'Search',
  'merchandising.advancedPrototype.responseSelection': 'Selection',
  'merchandising.advancedPrototype.responseEmpty': 'No products',
  'merchandising.advancedPrototype.searchTitle': 'Use normal search results',
  'merchandising.advancedPrototype.searchBody': 'Keep the original search candidate set, then apply rewrite, group priorities, pins and hidden products.',
  'merchandising.advancedPrototype.rewriteLabel': 'Search instead for',
  'merchandising.advancedPrototype.rewritePlaceholder': 'Optional replacement phrase',
  'merchandising.advancedPrototype.selectionTitle': 'Custom selection',
  'merchandising.advancedPrototype.selectionBody': 'The original query no longer limits this product set.',
  'merchandising.advancedPrototype.selectionGroups': '{count, plural, one {# group} other {# groups}}',
  'merchandising.advancedPrototype.editSelection': 'Edit selection',
  'merchandising.advancedPrototype.selectionSummary': 'Products match every condition in a group. A product may match any group.',
  'merchandising.advancedPrototype.emptyTitle': 'No silver jewelry in this catalog',
  'merchandising.advancedPrototype.emptyDefaultMessage': 'We do not carry silver jewelry, but you can explore visually similar pieces in white gold.',
  'merchandising.advancedPrototype.emptyMessage': 'Message to shoppers',
  'merchandising.advancedPrototype.emptyLinkToggle': 'Offer a helpful page link',
  'merchandising.advancedPrototype.emptyLinkLabel': 'Link label',
  'merchandising.advancedPrototype.emptyLinkDefaultLabel': 'Explore white gold rings',
  'merchandising.advancedPrototype.emptyLinkUrl': 'Relative URL',
  'merchandising.advancedPrototype.emptyLinkDefaultUrl': '/rings/white-gold',
  'merchandising.advancedPrototype.emptyBadge': 'No results',
  'merchandising.advancedPrototype.matchDialogTitle': 'When this rule matches',
  'merchandising.advancedPrototype.matchDialogBody': 'Use one clear matching strategy. Production preview will use the same backend matcher as shopper search.',
  'merchandising.advancedPrototype.matchModeLabel': 'Query matching strategy',
  'merchandising.advancedPrototype.matchExact': 'Exact phrase',
  'merchandising.advancedPrototype.matchForms': 'Word forms',
  'merchandising.advancedPrototype.matchConcept': 'Concept',
  'merchandising.advancedPrototype.aliases': 'Required aliases',
  'merchandising.advancedPrototype.exclusions': 'Excluded phrases',
  'merchandising.advancedPrototype.aliasSilver': 'silver',
  'merchandising.advancedPrototype.aliasSilverAdjective': 'silver jewelry',
  'merchandising.advancedPrototype.aliasSterling': 'sterling',
  'merchandising.advancedPrototype.exclusionWithoutSilver': 'without silver',
  'merchandising.advancedPrototype.exclusionNotSilver': 'not silver',
  'merchandising.advancedPrototype.testQuery': 'Test a query',
  'merchandising.advancedPrototype.testQueryPlaceholder': 'Try a shopper phrase',
  'merchandising.advancedPrototype.matchPositive': 'This rule will match',
  'merchandising.advancedPrototype.matchExcluded': 'Excluded phrase found',
  'merchandising.advancedPrototype.matchNegative': 'This rule will not match',
  'merchandising.advancedPrototype.matchPrompt': 'Enter a query to test this rule.',
  'merchandising.advancedPrototype.done': 'Done',
  'merchandising.advancedPrototype.selectionDialogTitle': 'Edit custom selection',
  'merchandising.advancedPrototype.selectionDialogBody': 'All conditions inside a group are required. Groups are alternatives and do not control product order.',
  'merchandising.advancedPrototype.group': 'Group {number}',
  'merchandising.advancedPrototype.groupRemove': 'Remove group {number}',
  'merchandising.advancedPrototype.groupCategory': 'Category for group {number}',
  'merchandising.advancedPrototype.groupMaterial': 'Material for group {number}',
  'merchandising.advancedPrototype.groupPrice': 'Maximum price for group {number}',
  'merchandising.advancedPrototype.category': 'Category',
  'merchandising.advancedPrototype.material': 'Material',
  'merchandising.advancedPrototype.maxPrice': 'Maximum price',
  'merchandising.advancedPrototype.addGroup': 'Add group',
  'merchandising.advancedPrototype.saveSelection': 'Save selection',
  'merchandising.advancedPrototype.cancel': 'Cancel',
  'merchandising.advancedPrototype.or': 'OR',
  'merchandising.advancedPrototype.discardTitle': 'Discard selection changes?',
  'merchandising.advancedPrototype.discardBody': 'Your selection edits have not been applied to this prototype.',
  'merchandising.advancedPrototype.keepEditing': 'Keep editing',
  'merchandising.advancedPrototype.discard': 'Discard changes',
  'merchandising.advancedPrototype.close': 'Close',
  'merchandising.advancedPrototype.prototypeSchedule': 'Schedule remains in the production position and follows the existing rule lifecycle.',
  'merchandising.advancedPrototype.product.ringWhiteGold': 'White gold ring with diamonds',
  'merchandising.advancedPrototype.product.ringClassic': 'Classic white gold ring',
  'merchandising.advancedPrototype.product.earrings': 'Diamond earrings for children',
  'merchandising.advancedPrototype.product.pendant': 'White gold heart pendant',
  'merchandising.advancedPrototype.product.goldRing': 'Yellow gold ring',
  'merchandising.advancedPrototype.product.goldEarrings': 'Yellow gold earrings',
  'merchandising.advancedPrototype.product.materialWhiteGold': 'White gold',
  'merchandising.advancedPrototype.product.materialYellowGold': 'Yellow gold',
  'merchandising.advancedPrototype.product.categoryRings': 'Rings',
  'merchandising.advancedPrototype.product.categoryEarrings': 'Earrings',
  'merchandising.advancedPrototype.product.categoryPendants': 'Pendants',
  'merchandising.advancedPrototype.product.materialDiamonds': 'Diamonds',
  'merchandising.advancedPrototype.product.audienceChildren': 'For children',
  'sidebar.search.merchandising.rules': 'Rules',
  'sidebar.search.merchandising.searchRules': 'Search Rules',
  'sidebar.search.merchandising.productRanking': 'Product Ranking',
  'sidebar.search.merchandising.categoryPriorities': 'Category Priorities',
  'merchandising.page.title': 'Merchandising Rules',
  'merchandising.page.description': 'Control category priorities, exact-query overrides and product ranking.',
  'merchandising.navigation.label': 'Merchandising workspaces',
  'merchandising.navigation.overview': 'Overview',
  'merchandising.navigation.categories': 'Category Priorities',
  'merchandising.navigation.query': 'Query Rules',
  'merchandising.navigation.products': 'Product Ranking',
  'merchandising.overview.categories.title': 'Category Priorities',
  'merchandising.overview.categories.description': 'Review automatic, AI and manual multipliers across the category tree.',
  'merchandising.overview.query.title': 'Query Rules',
  'merchandising.overview.query.description': 'Pin, hide, boost, bury, filter or redirect exact search queries.',
  'merchandising.overview.products.title': 'Product Ranking',
  'merchandising.overview.products.description': 'Multiply index scores for products matching catalog conditions.',
  'merchandising.workbench.searchTerms': 'Search phrases',
  'merchandising.workbench.searchTermsHint': 'Add phrases shoppers use to find these products.',
  'merchandising.workbench.searchTerms.boosted': 'High priority',
  'merchandising.workbench.searchTerms.mid': 'Normal priority',
  'merchandising.workbench.searchTermsAddLabel': 'New phrases',
  'merchandising.workbench.searchTermsPlaceholder': 'Type a phrase or paste several lines',
  'merchandising.workbench.searchTermsChoosePriority': 'Priority for new phrases',
  'merchandising.workbench.searchTermsAdd': 'Add',
  'merchandising.workbench.searchTermsAddAction': 'Add search phrases',
  'merchandising.workbench.searchTermsRemove': 'Remove {term}',
  'merchandising.workbench.searchTermsEmpty': 'No phrases yet',
  'merchandising.workbench.searchTermsLimit': 'Use up to 32 phrases per priority, each no longer than 100 characters.',
  'merchandising.condition.hasValue': 'has a value',
  'merchandising.condition.hasNoValue': 'has no value',
  'merchandising.overview.categories.counts': '{manual} manual · {ai} AI suggestions · {unsaved} unsaved',
  'merchandising.overview.query.counts': '{active} active · {draft} drafts · {scheduled} scheduled · {expired} expired',
  'merchandising.overview.products.counts': '{active} active · {draft} drafts · {waiting} waiting for reindex',
  'merchandising.overview.attention.title': 'Needs attention',
  'merchandising.overview.attention.empty': 'No attention items in the loaded session data.',
  'merchandising.overview.bounded': 'Counts and attention items cover only the bounded rows loaded in this session.',
  'merchandising.overview.attention.expired': 'Expired active rule: {name}',
  'merchandising.overview.attention.unresolved': 'Unresolved product target in {name}',
  'merchandising.overview.attention.ai': '{count} AI category suggestions await review',
  'merchandising.overview.attention.bulk': 'Bulk operation failed or conflicted for rule #{id}',
  'merchandising.overview.attention.categoryConflict': 'Category priority conflict for category #{id}',
  'merchandising.capability.unavailable': 'This surface is unavailable because its backend capability is disabled.',
  'merchandising.action.open': 'Open',
  'merchandising.action.retry': 'Retry',
  'merchandising.action.apply': 'Apply',
  'merchandising.action.loadMore': 'Load more',
  'merchandising.action.previous': 'Previous',
  'merchandising.action.next': 'Next',
  'merchandising.action.activate': 'Activate',
  'merchandising.action.disable': 'Disable',
  'merchandising.action.archive': 'Archive',
  'merchandising.action.delete': 'Delete',
  'merchandising.action.deletePermanently': 'Delete permanently',
  'merchandising.action.deleting': 'Deleting…',
  'merchandising.action.clear': 'Clear manual',
  'merchandising.action.accept': 'Accept',
  'merchandising.action.reject': 'Reject',
  'merchandising.action.refresh': 'Refresh',
  'merchandising.action.validate': 'Validate',
  'merchandising.action.saveDraft': 'Save draft',
  'merchandising.action.saveChanges': 'Save changes',
  'merchandising.action.discard': 'Discard',
  'merchandising.action.edit': 'Edit',
  'merchandising.action.remove': 'Remove',
  'merchandising.action.add': 'Add action',
  'merchandising.action.moveUp': 'Move up',
  'merchandising.action.moveDown': 'Move down',
  'merchandising.action.moveUpContext': 'Move action {index} up',
  'merchandising.action.moveDownContext': 'Move action {index} down',
  'merchandising.condition.moveUp': 'Move condition {index} up',
  'merchandising.condition.moveDown': 'Move condition {index} down',
  'merchandising.error.generic': 'The merchandising operation failed.',
  'merchandising.error.requestId': 'Request ID: {requestId}',
  'merchandising.filter.search': 'Search by name',
  'merchandising.filter.status': 'Status',
  'merchandising.filter.source': 'Source',
  'merchandising.filter.activeAt': 'Active at',
  'merchandising.filter.languageScope': 'Language scope',
  'merchandising.filter.scope.all': 'All scopes',
  'merchandising.filter.scope.language': 'Current language',
  'merchandising.filter.scope.neutral': 'Language-neutral',
  'merchandising.filter.all': 'All',
  'merchandising.filter.clearSelectionConfirm': 'Changing filters clears the current rule selection. Continue?',
  'merchandising.field.name': 'Name',
  'merchandising.field.description': 'Description',
  'merchandising.field.priority': 'Priority',
  'merchandising.field.languageId': 'Language ID',
  'merchandising.field.validFrom': 'Valid from',
  'merchandising.field.validTo': 'Valid to',
  'merchandising.field.exactQuery': 'Exact query',
  'merchandising.field.normalizedQuery': 'Normalized query',
  'merchandising.field.status': 'Status',
  'merchandising.field.source': 'Source',
  'merchandising.field.trigger': 'Trigger',
  'merchandising.field.ruleActions': 'Rule actions',
  'merchandising.field.schedule': 'Schedule',
  'merchandising.field.runtimeEffect': 'Runtime effect',
  'merchandising.field.updated': 'Updated',
  'merchandising.field.actions': 'Actions',
  'merchandising.status.draft': 'Draft',
  'merchandising.status.suggested': 'Suggested',
  'merchandising.status.active': 'Active',
  'merchandising.status.disabled': 'Disabled',
  'merchandising.status.archived': 'Archived',
  'merchandising.source.system': 'System',
  'merchandising.source.auto': 'Automatic',
  'merchandising.source.ai': 'AI',
  'merchandising.source.manual': 'Manual',
  'merchandising.trigger.conditions': '{count} conditions',
  'merchandising.trigger.none': 'No trigger',
  'merchandising.schedule.always': 'Always',
  'merchandising.schedule.scheduled': 'Scheduled',
  'merchandising.schedule.window': 'Active window',
  'merchandising.schedule.expired': 'Expired',
  'merchandising.runtime.immediate': 'Immediate',
  'merchandising.runtime.reindex_required': 'Reindex required',
  'merchandising.runtime.unknown': 'Unknown',
  'merchandising.kind.product_ranking': 'Product ranking',
  'merchandising.kind.query_override': 'Query override',
  'merchandising.library.product_ranking.title': 'Product Ranking Rules',
  'merchandising.library.product_ranking.description': 'Promote or demote groups of products across search.',
  'merchandising.library.query_override.title': 'Query Rules',
  'merchandising.library.query_override.description': 'Shape the results for a shopper’s exact search phrase.',
  'merchandising.library.table': 'Merchandising rules',
  'merchandising.library.empty': 'No rules match these filters.',
  'merchandising.rule.create': 'Create rule',
  'merchandising.rule.select': 'Select {name}',
  'merchandising.editor.new': 'New merchandising rule',
  'merchandising.editor.edit': 'Edit merchandising rule',
  'merchandising.editor.ruleType': 'Rule type',
  'merchandising.editor.typeChangeConfirm': 'Change rule type? Existing trigger, conditions and actions will be cleared.',
  'merchandising.editor.recovered': 'A draft from this session was recovered.',
  'merchandising.editor.unsavedWarning': 'You have unsaved merchandising changes. Leave this page?',
  'merchandising.unsaved.title': 'Discard unsaved changes?',
  'merchandising.unsaved.body': 'Your changes have not been saved. Leave this page and discard them?',
  'merchandising.unsaved.discard': 'Discard changes',
  'merchandising.unsaved.keepEditing': 'Keep editing',
  'merchandising.editor.reviewActivate': 'Review & activate',
  'merchandising.editor.returnToAnalytics': 'Return to analytics',
  'merchandising.conditions.title': 'Conditions',
  'merchandising.conditions.all': 'Match all',
  'merchandising.conditions.any': 'Match any',
  'merchandising.condition.field': 'Field',
  'merchandising.condition.operator': 'Operator',
  'merchandising.condition.operatorGroup.value': 'Value',
  'merchandising.condition.operatorGroup.list': 'List',
  'merchandising.condition.operatorGroup.text': 'Text',
  'merchandising.condition.operatorGroup.number': 'Number',
  'merchandising.condition.value': 'Value',
  'merchandising.condition.minimum': 'Minimum',
  'merchandising.condition.maximum': 'Maximum',
  'merchandising.condition.from': 'From',
  'merchandising.condition.to': 'To',
  'merchandising.condition.rangeOrder': '“From” must be less than or equal to “To”.',
  'merchandising.condition.regex.ariaLabel': '{field} regular expression',
  'merchandising.condition.regex.placeholder': 'e.g. ^(tent|shelter)\\b',
  'merchandising.condition.regex.tooLong': 'Regular expressions may contain at most 200 characters.',
  'merchandising.condition.regex.invalid': 'This regular expression is not valid.',
  'merchandising.condition.regex.unsupported': 'Lookarounds and backreferences are not supported.',
  'merchandising.condition.add': 'Add condition',
  'merchandising.value.true': 'True',
  'merchandising.value.false': 'False',
  'merchandising.selector.search': 'Search values',
  'merchandising.selector.results': 'Matching values',
  'merchandising.selector.empty': 'No matching values',
  'merchandising.selector.productsCount': '{count} products',
  'merchandising.editor.unsupportedDescriptor': '{key} is unsupported by this admin version. The stored value remains read-only.',
  'merchandising.editor.duplicateProduct': 'The same product cannot appear in more than one query action.',
  'merchandising.editor.duplicatePin': 'Pin positions must be unique.',
  'merchandising.editor.redirectExclusive': 'Redirect is exclusive and cannot be combined with result actions.',
  'merchandising.editor.actionConflict': '{left} conflicts with {right}.',
  'merchandising.editor.removeConflicts': 'This action conflicts with existing action cards. Remove the conflicting cards?',
  'merchandising.editor.languageNeutral': 'Product ranking rules are language-neutral.',
  'merchandising.editor.indexScheduleWarning': 'Index rules take effect only after publication and cannot be scheduled in this release.',
  'merchandising.actions.title': 'Actions',
  'merchandising.action.type': 'Action type',
  'merchandising.action.multiplier': 'Multiplier',
  'merchandising.action.productId': 'Product ID',
  'merchandising.action.position': 'Position',
  'merchandising.action.categoryIds': 'Category IDs',
  'merchandising.action.redirectUrl': 'Redirect URL',
  'merchandising.preview.title': 'Preview',
  'merchandising.preview.sideEffectFree': 'Preview is side-effect free and never saves this draft.',
  'merchandising.preview.run': 'Run preview',
  'merchandising.preview.running': 'Running…',
  'merchandising.preview.natural': 'Natural results',
  'merchandising.preview.adjusted': 'Adjusted results',
  'merchandising.preview.totals': 'Totals: natural {natural} · adjusted {adjusted}',
  'merchandising.preview.facets': 'Facet changes',
  'merchandising.preview.trace': 'Applied action trace',
  'merchandising.preview.skipped': 'Skipped targets',
  'merchandising.preview.hidden': 'Hidden targets',
  'merchandising.preview.factors': 'Score factors',
  'merchandising.preview.count.exact': 'Exact matched count',
  'merchandising.preview.count.bounded_estimate': 'Estimated matched count',
  'merchandising.preview.count.bounded_lower_bound': 'At least this many products match',
  'merchandising.preview.elapsed': '{elapsed} ms of {budget} ms budget',
  'merchandising.categories.title': 'Category Priorities',
  'merchandising.categories.description': 'Set the relative importance of categories in search ranking.',
  'merchandising.category.filter': 'Filter categories',
  'merchandising.category.select': 'Select {name}',
  'merchandising.category.expand': 'Expand {name}',
  'merchandising.category.collapse': 'Collapse {name}',
  'merchandising.category.products': '{count} products',
  'merchandising.category.brokenParent': 'Missing parent {id}; shown at root for recovery.',
  'merchandising.category.manualMultiplier': 'Manual multiplier for {name}',
  'merchandising.category.exactMultiplier': 'Exact manual multiplier',
  'merchandising.category.values': 'Auto {auto} · AI {ai} · Manual {manual} · Ancestor {ancestor} · Effective {effective}',
  'merchandising.category.formula': '{ancestor} × {local} = {effective} (backend)',
  'merchandising.category.saveChanges': 'Save changes ({count})',
  'merchandising.category.sourceAndLocal': '{source} · Local {local}',
  'merchandising.category.pendingValue': 'Pending local value',
  'merchandising.category.pendingNotice': 'The effective value is recalculated by the backend after save.',
  'merchandising.category.editTitle': 'Edit {name}',
  'merchandising.category.demote': 'Demote',
  'merchandising.category.neutral': 'Neutral',
  'merchandising.category.boost': 'Boost',
  'merchandising.category.useAutomatic': 'Use automatic',
  'merchandising.category.automaticPreview': 'Clearing manual reveals the current AI/automatic value: {value}.',
  'merchandising.category.mixedNonAtomic': 'This mixed set and clear save is not atomic. Manual sets are verified before clear requests begin.',
  'merchandising.category.recovered': '{count} category changes were confirmed from the refreshed backend after a lost response.',
  'merchandising.category.keepLatest': 'Keep latest',
  'merchandising.category.reapply': 'Reapply my value',
  'merchandising.category.attention': 'Attention',
  'merchandising.category.sourceFilter.all': 'All sources',
  'merchandising.category.sourceFilter.manual': 'Manual',
  'merchandising.category.sourceFilter.ai': 'Accepted/suggested AI',
  'merchandising.category.sourceFilter.auto': 'Automatic',
  'merchandising.category.sourceFilter.neutral': 'Neutral',
  'merchandising.category.attentionFilter.all': 'All rows',
  'merchandising.category.attentionFilter.ai': 'AI suggestions',
  'merchandising.category.attentionFilter.changed': 'Changed only',
  'merchandising.category.attentionFilter.conflict': 'Conflicts',
  'merchandising.category.expandAll': 'Expand all',
  'merchandising.category.collapseAll': 'Collapse all',
  'merchandising.category.selectDescendants': 'Select visible descendants ({count})',
  'merchandising.category.selectDescendantsConfirm': 'Select {count} descendant rows in addition to the current selection?',
  'merchandising.ai.acceptTitle': 'Review AI suggestion',
  'merchandising.ai.rejectTitle': 'Reject AI suggestion',
  'merchandising.ai.reviewCount': '{count} suggestions will be reviewed with itemized results.',
  'merchandising.ai.noRationale': 'No rationale supplied',
  'merchandising.ai.manualPrecedence': 'The manual override remains higher precedence after acceptance.',
  'merchandising.ai.acceptEffect': 'Accepted AI becomes available as a distinct source. Category ranking changes require a full reindex.',
  'merchandising.ai.rejectEffect': 'Rejected proposals are archived and have no runtime effect.',
  'merchandising.ai.result': '{succeeded} suggestions reviewed · {failed} failed.',
  'merchandising.index.title': 'Merchandising index',
  'merchandising.index.loading': 'Loading index state',
  'merchandising.index.clean': 'Up to date',
  'merchandising.index.dirty': 'Reindex required',
  'merchandising.index.building': 'Building',
  'merchandising.index.failed': 'Build failed',
  'merchandising.index.unknown': 'Unknown',
  'merchandising.index.revision': 'Configuration {config} · live index {live}',
  'merchandising.index.start': 'Start full index',
  'merchandising.index.refreshStatus': 'Refresh job status',
  'merchandising.index.history': '{count} recent index jobs',
  'merchandising.index.dirtyReasons': 'Reasons: {reasons}',
  'merchandising.index.progress': '{progress}% complete',
  'merchandising.index.confirmTitle': 'Start full reindex',
  'merchandising.index.confirmMessage': 'The storefront keeps serving the last published index while the new generation is built.',
  'merchandising.index.current': 'Search index is up to date',
  'merchandising.index.pendingChanges': '{count} index changes',
  'merchandising.index.publishing': 'Publishing search index…',
  'merchandising.index.publicationFailed': 'Publication failed',
  'merchandising.index.viewPublicationStatus': 'View publication status',
  'merchandising.index.publicationStatus': 'Publication status',
  'merchandising.index.immediateChanges': 'Immediate changes',
  'merchandising.index.immediateLive': 'Search rules are live immediately',
  'merchandising.index.immediateMembershipPending': 'Product, rewrite, and redirect actions are live immediately. Category and brand actions take effect when the catalog index is published.',
  'merchandising.workbench.membershipPreviewPending': 'Category preview is unavailable until the one-time catalog membership index is published. Other draft actions are still previewed.',
  'merchandising.workbench.factsPreviewPending': 'Brand preview is unavailable until catalog facts are published. Other draft actions are still previewed.',
  'merchandising.index.indexChanges': 'Index changes',
  'merchandising.index.waiting': 'Changes waiting to be published',
  'merchandising.index.publishIndex': 'Publish search index',
  'merchandising.index.rebuildIndex': 'Rebuild search index',
  'merchandising.index.catalogRecoveryRequired': 'Catalog publication was interrupted. Complete a full catalog upload before publishing search changes.',
  'merchandising.workbench.merchandising': 'Merchandising',
  'product.selector.search.error': 'Product search failed. Try again.',
  'product.selector.resolve.error': 'Saved product details could not be resolved. The IDs remain available for removal.',
  'product.selector.unresolved': 'Unresolved product',
  'merchandising.transfer.duplicate': 'Duplicate as draft',
  'merchandising.transfer.export': 'Export',
  'merchandising.transfer.exportJson': 'Export JSON',
  'merchandising.transfer.exportCsv': 'Export CSV',
  'merchandising.transfer.import': 'Import',
  'merchandising.transfer.title': 'Import and export rules',
  'merchandising.transfer.duplicateTitle': 'Duplicate selected rules',
  'merchandising.transfer.importTitle': 'Review imported rules',
  'merchandising.transfer.duplicateResultTitle': 'Duplicate results',
  'merchandising.transfer.importResultTitle': 'Import results',
  'merchandising.transfer.exportResultTitle': 'Export results',
  'merchandising.transfer.validationSummary': '{successful} valid · {failed} invalid',
  'merchandising.transfer.invalidExcluded': 'Invalid rows are excluded and will not be created.',
  'merchandising.transfer.draftOnly': 'Import and duplicate create manual drafts only. They never activate rules.',
  'merchandising.transfer.csvPreview': '{rules, plural, one {# draft rule} other {# draft rules}} from {rows, plural, one {# CSV row} other {# CSV rows}}.',
  'merchandising.transfer.csvInvalid': 'Fix the listed CSV rows before creating drafts.',
  'merchandising.transfer.csvFile': 'CSV',
  'merchandising.transfer.csvRow': 'Row {row}',
  'merchandising.transfer.result': '{successful, plural, =0 {No drafts were created} one {# draft created} other {# drafts created}}. {failed, plural, =0 {All selected rules are ready.} one {# rule needs attention.} other {# rules need attention.}}',
  'merchandising.transfer.unnamedRule': 'Rule {number}',
  'merchandising.transfer.validationFailed': 'This rule did not pass validation.',
  'merchandising.transfer.createFailed': 'The draft could not be created.',
  'merchandising.transfer.exportPartial': '{successful} rules were exported and {failed} could not be loaded. The downloaded manifest is marked incomplete.',
  'merchandising.transfer.close': 'Close',
  'merchandising.transfer.createDrafts': 'Create drafts ({count})',
  'merchandising.transfer.retryFailed': 'Retry failed drafts ({count})',
  'merchandising.bulk.selected': '{count} selected',
  'merchandising.bulk.activate': 'Activate selected',
  'merchandising.bulk.disable': 'Disable selected',
  'merchandising.bulk.archive': 'Archive selected',
  'merchandising.bulk.cancel': 'Cancel',
  'merchandising.bulk.retry': 'Retry failed ({count})',
  'merchandising.bulk.progress': '{completed} of {total} finished. Completed changes are not rolled back.',
  'merchandising.bulk.itemStatus': 'Rule {id}: {status}',
  'merchandising.bulk.itemError': 'Error: {error}',
  'merchandising.bulk.archiveTitle': 'Archive selected rules',
  'merchandising.bulk.archiveWarning': 'Archive is irreversible and this multi-rule operation is not atomic. Completed archives will remain if another item fails.',
  'merchandising.bulk.typeCount': 'Type {count} to confirm',
  'merchandising.bulk.archiveConfirm': 'Archive confirmation count',
  'merchandising.explain.title': 'Backend explanation',
  'merchandising.explain.open': 'Explain',
  'merchandising.explain.close': 'Close',
  'merchandising.analytics.actions': 'Merchandising',
  'merchandising.analytics.createRule': 'Create rule',
  'merchandising.editor.invalidPrefill': 'The analytics prefill is invalid or too large. Return to analytics and try again.',
  'merchandising.category.partialClearFailure': 'Manual set changes remain applied. {count} clear changes are still pending; retry sends only those clears.',
  'merchandising.conflict.message': 'This rule changed on the server (revision {revision}). Nothing was overwritten.',
  'merchandising.conflict.useLatest': 'Use latest',
  'merchandising.conflict.reapply': 'Reapply my draft',
  'merchandising.conflict.openLatest': 'Open latest in new view',
  'merchandising.activation.title': 'Review activation',
  'merchandising.activation.effect': 'Runtime effect: {effect}',
  'merchandising.activation.conflict': 'Another active rule already owns this exact slot.',
  'merchandising.activation.reindexConsequence': 'Activation changes configuration now, but storefront ranking changes only after a successful full reindex.',
  'merchandising.lifecycle.disableTitle': 'Disable rule',
  'merchandising.lifecycle.disableWarning': 'Disable {name}? Runtime effect: {effect}. Indexed data may remain stale until a full reindex.',
  'merchandising.lifecycle.archiveTitle': 'Archive rule',
  'merchandising.lifecycle.archiveWarning': 'Archive {name}? Archiving is irreversible in v1 and may leave indexed data stale until a full reindex.',
  'merchandising.lifecycle.typeRuleName': 'Type the rule name to confirm',
  'merchandising.lifecycle.archiveConfirmation': 'Archive confirmation rule name',
  'merchandising.category.setSelected': 'Set selected',
  'merchandising.category.clearSelected': 'Clear selected',
  'merchandising.category.acceptSelectedAi': 'Accept selected AI',
  'merchandising.category.rejectSelectedAi': 'Reject selected AI',
  'merchandising.workbench.logic.label': 'Condition logic',
  'merchandising.workbench.logic.and': 'AND',
  'merchandising.workbench.logic.or': 'OR',
  'merchandising.workbench.duplicateNamed': 'Duplicate {name}',
  'merchandising.workbench.deleteNamed': 'Delete {name} permanently',
  'merchandising.workbench.deleteTitle': 'Delete rule?',
  'merchandising.workbench.deleteWarning': '{count, plural, one {This rule} other {These # rules}} will be permanently deleted. This cannot be undone.',
  'merchandising.workbench.rangeTo': 'to',
  'merchandising.workbench.editValues': 'Edit values',
  'merchandising.workbench.addValue': 'Add value',
  'merchandising.workbench.chooseValues': 'Choose values',
  'merchandising.workbench.removeFilter': 'Remove {name} filter',
  'merchandising.workbench.groupFilterHint': 'Group with this filter',
  'merchandising.workbench.rankingIncomplete': 'Complete at least one product filter and choose a non-natural priority.',
  'merchandising.workbench.filterGroup': 'Filter group',
  'merchandising.workbench.ungroup': 'Ungroup',
  'merchandising.workbench.archivedRanking': 'Archived rules are read-only. Duplicate this rule to make changes.',
  'merchandising.workbench.archivedQuery': 'Archived search rules are read-only. Duplicate this rule to make changes.',
  'merchandising.workbench.startsUtc': 'Starts (UTC)',
  'merchandising.workbench.endsUtc': 'Ends (UTC)',
  'merchandising.workbench.productFilters': 'Product filters',
  'merchandising.workbench.ruleNameOptional': 'Rule name (optional)',
  'merchandising.workbench.generatedRuleName': 'Generated from the selected filters',
  'merchandising.workbench.addFilter': 'Add filter',
  'merchandising.workbench.productPriority': 'Product priority',
  'merchandising.workbench.matchingProducts': 'Matching products',
  'merchandising.workbench.matching': 'matching',
  'merchandising.workbench.previewProducts': '{count} preview products',
  'merchandising.workbench.chooseProductFilter': 'Choose product filter',
  'merchandising.workbench.queryGroupsUnavailable': 'Query groups are not available in this plugin version.',
  'merchandising.workbench.relatedSearches': '+{count} related searches',
  'merchandising.workbench.queryRequired': 'Add at least one search phrase.',
  'merchandising.workbench.queryStartTitle': 'Start with a search query',
  'merchandising.workbench.queryStartBody': 'Enter the phrase shoppers use to preview and arrange its results.',
  'merchandising.workbench.queryPlaceholder': 'Enter a search query',
  'merchandising.workbench.changeRequired': 'Make at least one merchandising change.',
  'merchandising.workbench.untitledSearch': 'Untitled search',
  'merchandising.workbench.removeQuery': 'Remove {query}',
  'merchandising.workbench.productsCount': '{count} products',
  'merchandising.workbench.addAndPin': 'Add & pin',
  'merchandising.workbench.importSearchRules': 'Import search rules',
  'merchandising.workbench.queryTransferTitle': 'Search-rule transfer',
  'merchandising.workbench.queryTransferResult': '{successful} drafts created or exported · {failed} failed',
  'merchandising.workbench.setPriority': 'Set priority',
  'merchandising.workbench.bulkEdit': 'Bulk edit',
  'merchandising.workbench.categoriesCount': '{count} categories',
  'merchandising.workbench.directProducts': 'Direct products',
  'merchandising.workbench.subtreeProducts': 'Products in subtree',
  'merchandising.workbench.selectedOnly': 'Selected categories only',
  'merchandising.workbench.includeDescendants': 'Include {count} descendants',
  'merchandising.workbench.lower': 'Lower',
  'merchandising.workbench.higher': 'Higher',
  'merchandising.workbench.mixedPriority': 'Mixed priorities',
  'merchandising.workbench.bulkCategoryPriority': 'Bulk category priority',
  'merchandising.workbench.priorityFor': 'Priority for {name}',
  'merchandising.workbench.resetAutomatic': 'Reset to automatic',
  'merchandising.workbench.local': 'Local',
  'merchandising.workbench.parents': 'Parents',
  'merchandising.workbench.result': 'Result',
  'merchandising.workbench.applyPriority': 'Apply priority',
  'merchandising.workbench.exportCsv': 'Export CSV',
  'merchandising.workbench.importCsv': 'Import CSV',
  'merchandising.workbench.searchCategories': 'Search categories by name or ID',
  'merchandising.workbench.category': 'Category',
  'merchandising.workbench.effectivePriority': 'Effective priority',
  'merchandising.workbench.importCategoryPriorities': 'Import category priorities',
  'merchandising.workbench.categoryCsv': 'Category priority CSV',
  'merchandising.workbench.importChanges': 'Import changes',
  'merchandising.workbench.multiplierSymbol': '×',
  'merchandising.workbench.addProduct': 'Add product',
  'merchandising.workbench.addRelatedSearch': 'Add query variant',
  'merchandising.workbench.addSearch': 'Add search',
  'merchandising.workbench.advancedOptions': 'Advanced options',
  'merchandising.workbench.sameChangesApply': 'Same changes apply to',
  'merchandising.workbench.queryVariantHelp': 'Use close variants such as singular, plural, synonyms, or campaign wording. Pins can add products; group priorities only affect products already found for each variant. Preview every variant before publishing.',
  'merchandising.workbench.ruleAutoname': 'The rule will be listed by its shopper search. A name is not required.',
  'merchandising.workbench.rankingAutoname': 'The rule will be listed by its product set and effect. A name is not required.',
  'merchandising.workbench.rewriteHelp': 'Use another search phrase while keeping shoppers on the results page.',
  'merchandising.workbench.resultGroupsHelp': 'Use categories and brands found in this result set. Counts come from the current search.',
  'merchandising.workbench.groupPriorityExplanation': 'Priority changes relevance strength; it does not lock the group to the top.',
  'merchandising.workbench.productSearchHelp': 'These products do not currently match this search.',
  'merchandising.workbench.allStatuses': 'All statuses',
  'merchandising.workbench.appliesTo': 'Applies to',
  'merchandising.workbench.arrangeResultsFor': 'Arrange results for',
  'merchandising.workbench.backToRanking': 'Back to product ranking',
  'merchandising.workbench.backToRules': 'Back to search rules',
  'merchandising.workbench.brands': 'Brands',
  'merchandising.workbench.categories': 'Categories',
  'merchandising.workbench.changes': 'Changes',
  'merchandising.workbench.createRankingRule': 'Create ranking rule',
  'merchandising.workbench.createSearchRule': 'Create search rule',
  'merchandising.workbench.effect': 'Effect',
  'merchandising.workbench.of': 'of',
  'merchandising.workbench.page': 'Page',
  'merchandising.workbench.previewingSearch': 'Previewing search',
  'merchandising.workbench.previewMode': 'Result view',
  'merchandising.workbench.previewDraft': 'Preview',
  'merchandising.workbench.liveResults': 'Live',
  'merchandising.workbench.originalResults': 'Original',
  'merchandising.workbench.changesOnly': 'Changes',
  'merchandising.workbench.previewRefreshing': 'Updating preview…',
  'merchandising.workbench.noPreviewChanges': 'No merchandising changes yet.',
  'merchandising.workbench.changeRewrite': 'Search instead for “{query}”',
  'merchandising.workbench.changePin': 'Pin {product} at position {position}',
  'merchandising.workbench.changeHide': 'Hide {product}',
  'merchandising.workbench.changeGroupExclude': 'Exclude {group}',
  'merchandising.workbench.changeGroupPriority': '{direction} {group} · {factor}×',
  'merchandising.workbench.productSearch': 'Find a product',
  'merchandising.workbench.publish': 'Publish',
  'merchandising.workbench.query': 'Search query',
  'merchandising.workbench.rankingPlaceholder': 'Search product-ranking rules',
  'merchandising.workbench.relatedSearch': 'Related search',
  'merchandising.workbench.resetChanges': 'Reset changes',
  'merchandising.workbench.resultsPhrase': 'Search instead for',
  'merchandising.workbench.resultGroups': 'Result groups',
  'merchandising.workbench.searchInstead': 'Use another search phrase',
  'merchandising.workbench.searchResults': 'Search results',
  'merchandising.workbench.searchRulesPlaceholder': 'Search rules or queries',
  'merchandising.workbench.searchCount': '{count, plural, one {# search} other {# searches}}',
  'merchandising.workbench.arrangedResults': 'Arranged results',
  'merchandising.workbench.sharedSearches': 'Shared across {count} searches',
  'merchandising.workbench.selected': 'selected',
  'merchandising.workbench.selectAll': 'Select all visible rows',
  'merchandising.workbench.teamNote': 'Team note',
  'merchandising.workbench.ruleSettings': 'Rule settings',
  'merchandising.workbench.scheduleEnabled': 'Scheduled',
  'merchandising.workbench.noSchedule': 'No schedule',
  'merchandising.workbench.starts': 'Starts',
  'merchandising.workbench.ends': 'Ends',
  'merchandising.workbench.clearDate': 'Clear',
  'merchandising.workbench.firstPage': 'First page',
  'merchandising.workbench.lastPage': 'Last page',
  'merchandising.workbench.priority.extraLow': 'Extra low',
  'merchandising.workbench.priority.lower': 'Lower',
  'merchandising.workbench.priority.natural': 'Natural',
  'merchandising.workbench.priority.higher': 'Higher',
  'merchandising.workbench.priority.extraHigh': 'Extra high',
  'merchandising.workbench.categoryPriorities': 'Category priorities',
  'merchandising.workbench.productRanking': 'Product ranking',
  'merchandising.workbench.searchRules': 'Search rules',
  'merchandising.workbench.rulesLanguage': 'Search rules language',
  'merchandising.workbench.defaultLanguage': 'Default fallback',
  'merchandising.workbench.emptyHeading': 'Nothing here yet',
  'merchandising.workbench.emptyBody': 'Create the first rule to shape what shoppers see.',
  'merchandising.workbench.loadError': 'Rules could not be loaded. Your work is safe.',
  'merchandising.workbench.separator': '·',
  'merchandising.workbench.restore': 'Restore',
  'merchandising.workbench.hide': 'Hide',
  'merchandising.workbench.unpin': 'Unpin',
  'merchandising.workbench.pinAfterCurrent': 'Pin after current pinned products',
  'merchandising.workbench.reorderProduct': 'Change pinned position for',
  'merchandising.workbench.moveEarlier': 'Move one position earlier',
  'merchandising.workbench.moveLater': 'Move one position later',
  'merchandising.workbench.hidden': 'Hidden',
  'merchandising.workbench.excludedByGroup': 'Excluded by group',
  'merchandising.workbench.hideExcluded': 'Hide excluded',
  'merchandising.workbench.showExcluded': 'Show excluded',
  'merchandising.workbench.increased': 'Increased',
  'merchandising.workbench.decreased': 'Decreased',
  'merchandising.workbench.naturalOrder': 'Natural order',
  'merchandising.workbench.productsLower': 'products',
  'merchandising.workbench.excluded': 'Excluded',
  'merchandising.workbench.done': 'Done',
  'merchandising.workbench.editPriority': 'Edit priority',
  'merchandising.workbench.doneEditing': 'Done editing',
  'merchandising.workbench.exclude': 'Exclude',
  'merchandising.workbench.priorityStrength': 'Priority strength',
  'merchandising.workbench.saveCategoryChanges': 'Save category changes',
  'merchandising.workbench.csvCategoryMissing': 'Row {row}: category #{id} was not found.',
  'merchandising.workbench.csvMultiplierInvalid': 'Row {row}: multiplier must be 0.25, 0.5, 1, 2, or 4.',
  'merchandising.workbench.invalidSchedule': 'The end time must be later than the start time.',
};

export default merchandisingMessages;
